import type { TextKey } from '../../i18n/i18n';

export interface Credit {
  readonly text: TextKey;
  readonly links: readonly { readonly label: TextKey; readonly href: string }[];
}

/** Whose work the game is built on, as their licences ask to be told. */
export const credits: readonly Credit[] = [
  {
    text: 'credits-crowd',
    links: [
      { label: 'credits-source', href: 'https://opengameart.org/content/free-crowd-cheering-sounds' },
      { label: 'credits-license', href: 'https://creativecommons.org/licenses/by/4.0/' },
    ],
  },
  { text: 'credits-impacts', links: [{ label: 'credits-source', href: 'https://kenney.nl/assets/impact-sounds' }] },
  { text: 'credits-fonts', links: [{ label: 'credits-license', href: 'https://openfontlicense.org' }] },
  { text: 'credits-code', links: [] },
];

/** Every licence in full, written next to the page when the game is built. */
export const licensesFile = 'licenses.txt';
